import { ModalFuncProps } from "ant-design-vue"

/**
 * 懒加载
 */
export class Lazy<T> {
  private instance: T | null = null
  private readonly initializer: ILazyInitializer<T>

  constructor(initializer: ILazyInitializer<T>) {
    this.initializer = initializer
  }

  public get value() {
    if (this.instance === null) {
      this.instance = this.initializer()
    }
    return this.instance
  }
}

/**
 * 普通的异常类
 */
export class NormalException extends Error {
  constructor(err: string) {
    super(err)
  }
}


/**
 * 模态框API调用
 */
export interface ModalApi {
  confirm: (config: ModalFuncProps) => void,
  error: (config: ModalFuncProps) => void,
  info: (config: ModalFuncProps) => void,
  success: (config: ModalFuncProps) => void,
  warning: (config: ModalFuncProps) => void,
  destroyAll: () => void
}

/**
 * 商户类型
 */
export enum StoreType {
  // 普通商户
  Normal = 1,
  // 连锁总店
  Linkage = 2
}

/**
 * 商品类型
 */
export enum GoodType {
  // 普通商品
  normal = 1,
  // 套餐
  setMeal = 2
}

/**
 * 商品状态
 */
export enum GoodStatus {
  // 上架
  up = 0,
  // 下架
  down = 1
}

/**
 * 商品销售范围
 */
export enum GoodScope {
  // 外卖
  out = 1,
  // 堂食
  in = 2,
  // 外卖与堂食
  all = 3
}

/**
 * 员工岗位
 */
export enum StaffPost {
  // 管理员
  manager = 1,
  // 服务员
  waiter = 2,
  // 收银员
  cashier = 4,
  // 厨师
  cooker = 8
}


/**
 * 订单来源
 */
export enum OrderSource {
  // 未定义
  none = 0,
  // 外卖
  out = 1,
  // 扫码点餐
  scan = 2,
  // 收银台
  cachier = 3
}

/**
 * 店内订单状态
 */
export enum StoreOrderStatus {
  // 正在点单
  ordering = 1,
  // 正在用餐
  eating = 2,
  // 已结算
  settled = 4,
  // 反结算
  unsettled = 8,
  // 已取消
  cancel = 16,
  // 已退款
  refunded = 32
}

/**
 * 店内订单商品状态
 */
export enum StoreOrderGoodStatus {
  // 正在点菜
  ordering = 1,
  // 已点菜
  ordered = 2,
  // 正在加菜
  adding = 4,
  // 已加菜
  added = 8,
  // 已退菜
  returned = 16,
}

/**
 * 订单活动类别
 */
export enum OrderActivityType {
  // 未定义
  none = 0,
  // 新客立减
  newCustom = 1,
  // 满减
  fullReduce = 2,
  // 优惠券
  coupon = 3,
  // 商品折扣
  goodDiscount = 4,
  // 订单折扣
  orderDiscount = 5,
  // 整单立减
  orderPreferential = 6
}

/**
 * 数据绑定的类型
 */
export enum BindType {
  /**
   * 厨师
   */
  cook = 1,
  /**
   * 档口
   */
  stall = 2,
  /**
   * 收银员
   */
  cashier = 3,
}

/**
 * 订单类型
 */
export enum OrderType {
  /**堂食 */
  Store,
  /**外卖 */
  Out
}

/**
 * 数据字典分组
 */
export enum DataDicGroup {
  /**
   * 商品类别
   */
  GoodCategory = 'GoodCategory',
  /**
   * 商品属性
   */
  GoodAttribute = 'GoodAttribute',
  /**
   * 商品标签
   */
  GoodTags = 'GoodTags',
  /**
   * 餐台分类
   */
  DeskCategory = 'DeskCategory',
  /**
   * 餐位费
   */
  MealCost = 'MealCost',
  /**
   * 付款方式
   */
  StorePayment = 'StorePayment',
  /**
   * 午市与晚市的时间
   */
  StoreTime = 'StoreTime',
  /**
   * 档口
   */
  Stall = 'Stall',
  /**
   * 标签打印商品定义
   */
  TagPrint = 'TagPrint',
  /**
   * 退菜原因
   */
  ReturnGoodReason = 'ReturnGoodReason',
  /**
   * 自定义优惠方式
   */
  CustomOffers = 'CustomOffers',
  /**
   * 预设整单备注
   */
  OrderRemark = 'OrderRemark',
  /**
   * 预设单品备注
   */
  GoodRemark = 'GoodRemark',
  /**门店活动 */
  StoreActivity = 'StoreActivity',
  /**第三方应用接口 */
  ThirdpartInterface = 'ThirdpartInterface',
  /**物料信息 */
  Material = 'Material',
  /**商城商品类型 */
  MallGoodCategory = 'MallGoodCategory',
  /**京东商品映射 */
  JingdongMapping = 'JingdongMapping',
  /**美团商品映射 */
  MeituanMapping = 'MeituanMapping',
  /**饿了么商品映射 */
  ElemeMapping = 'ElemeMapping',
}

/**
 * 营销类型
 */
export enum MarketingType {
  /**
   * 商品券
   */
  Good = 1,
  /**
   * 满减券
   */
  FullReduce = 2,
}

/**
 * 送货方式
 */
export enum DeliveryMode {
  /**第三方平台 */
  Third = 'Third',
  /**自己配送 */
  Own = 'Own',
  /**自提 */
  Self = 'Self'
}

/**门店活动类型 */
export enum StoreActivityType {
  /**新客立减 */
  New = 'New',
  /**满减 */
  FullReduce = 'FullReduce',
  /**优惠券 */
  Coupon = 'Coupon',
  /**折扣券 */
  Discount = 'Discount',
  /**下单返券 */
  Return = 'Return',
  /**商品券 */
  Good = 'Good'
}

/**
 * 退款状态
 */
export enum OutOrderRefundStatus {
  /**正常订单，未执行退款 */
  None = 'None',
  /**正在申请退款 */
  Apply = 'Apply',
  /**已退款 */
  Finish = 'Finish'
}

/**
 * 物流类型
 */
export enum LogisticsType {
  /**未定义 */
  None = 'None',
  /**自己配送 */
  Self = 'Self',
  /**达达配送 */
  Dada = 'Dada',
  /**美团配送 */
  Meituan = 'Meituan',
  /**蜂鸟配送 */
  Fengniao = 'Fengniao',
  /**点我达配送 */
  Dianwoda = 'Dianwoda',
  /**一城飞客 */
  Yichengfeike = 'Yichengfeike',
  /**顺丰同城 */
  Shunfeng = 'Shunfeng'
}

/**外卖订单商品状态 */
export enum OutOrderGoodStatus {
  /**正常状态 */
  Normal = 'Normal',
  /**正在退款 */
  Refunding = 'Refunding',
  /**已退款 */
  Refunded = 'Refunded'
}

/**
 * 外卖订单状态
 */
export enum OutOrderStatus {
  /**已付款（前：商家待接单，后：已付款），有效订单 */
  Payed = 1,
  /**拒绝接单（前：已拒单，后：已拒单），无效订单 */
  Cancel = 2,
  /**商家已接单（前：商家已接单，后：待配送），有效订单 */
  Receipted = 4,
  /**待取货（前：骑手待取货，后：待配送），有效订单 */
  DistributorReceipt = 8,
  /**配送中（前：骑手配送中，后：配送中），有效订单 */
  Distribution = 16,
  /**配送异常，无效订单 */
  Exception = 32,
  /**已送达（前：待确认收货，后：已送达），有效订单 */
  Achieve = 64,
  /**已完成（前：订单已完成，后：用户已确认收货），有效订单 */
  Finish = 128,
  /**未付款，无效订单 */
  NotPay = 256,
  /**已评价（前：订单已完成，后：已评价），有效订单 */
  Appraised = 512,
  /**已关闭，无效订单 */
  Close = 1024,
  /**订单配送已取消 */
  CallOff = 2048,
  /**支付超时 */
  Overtime = 4096,

  /**无效订单 */
  Invalid = 2 + 32 + 256 + 1024 + 4096,

  /**有效订单 */
  Valid = 1 + 4 + 8 + 16 + 64 + 128 + 512 + 2048,

  /**显示退款按钮 */
  CanRefund = 4 + 64 + 128 + 512 + 2048,

  /**可直接完成的状态 */
  CanFinish = 8 + 16 + 32
}

/**商城订单状态 */
export enum MallOrderStatus {
  /**未付款 */
  NotPay = 'NotPay',
  /**正常 */
  Normal = 'Normal',
  /**已完成 */
  Finish = 'Finish',
  /**已取消 */
  Cancel = 'Cancel',
  /**已退款 */
  Refunded = 'Refunded',
  /**已发货 */
  Sended = 'Sended'

}

/**营销卡券使用范围 */
export enum MarketingScoped {
  /**门店券 */
  Store = 1,
  /**外卖券 */
  Out = 2,
  /**商城券 */
  Mall = 4
}

/**活动来源 */
export enum ActivitySource {
  /**外卖活动 */
  OutActivity = 'OutActivity',
  /**会员优惠券 */
  MemberCoupon = 'MemberCoupon',
  /**会员优惠券 */
  ScoreCoupon = 'ScoreCoupon'
}

/**活动标签 */
export enum ActivityTag {
  /**生日 */
  Birth = 'Birth',
  /**春节 */
  Spring = 'Spring'
}

/**平台订单的来源 */
export enum PlatformOrderSource {
  /**京东 */
  Jingdong = 'Jingdong',
  /**美团 */
  Meituan = 'Meituan',
  /**饿了么 */
  Eleme = 'Eleme',
}